import React, { FC } from "react";
import { ButtonGroup, IconButton, SxProps, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const quantityField: SxProps = {
  height: "14px",
  color: "black",
};

const contatiner: SxProps = {
  borderRadius: "8px",
  backgroundColor: "#E8E8E8",
  border: 1,
  borderColor: "#333333",
  height: "36px",
  minWidth: "100px",
  justifyContent: "space-between",
  alignItems: "center",
};

type QuantityFieldProps = {
  qty: number;
  setQty: (qty: number) => void;
};

const QuantityField: FC<QuantityFieldProps> = ({ qty, setQty }) => (
  <ButtonGroup sx={contatiner}>
    <IconButton onClick={() => setQty(qty - 1)} disabled={qty <= 1}>
      <RemoveIcon sx={quantityField} />
    </IconButton>
    <Typography>{qty}</Typography>
    <IconButton name="add" onClick={() => setQty(qty + 1)}>
      <AddIcon sx={quantityField} />
    </IconButton>
  </ButtonGroup>
);

export default QuantityField;
